import { AgencyNoticeExhibition } from "~/apps/shared/constants/enums";
import { Error } from "~/apps/shared/types";
import { Either, failure, success } from "~/apps/shared/utils/either";
import { formatServiceError } from "~/apps/shared/utils/errors";

import * as agencyNoticeApi from "../apis/agency-notice.api";
import { AgencyNotice } from "../models/agency-notice.model";

export const listClientAgencyNotices = async (
  clientToken: string,
  exhibition?: AgencyNoticeExhibition,
): Promise<Either<Error, AgencyNotice[]>> => {
  try {
    return success(
      await agencyNoticeApi.listClientAgencyNotices(clientToken, exhibition),
    );
  } catch (error) {
    return failure(formatServiceError({ error }));
  }
};
